var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "footer-right" }, [
      _c("div", { staticClass: "footer-right-list" }, [
        _c("ul", [
          _c("li", { staticClass: "right-list-title" }, [_vm._v("Company")]),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open("/about")
                }
              }
            },
            [_vm._v("Our Story")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open("/contact")
                }
              }
            },
            [_vm._v("Contact Us")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer-right-list" }, [
        _c("ul", [
          _c("li", { staticClass: "right-list-title" }, [
            _vm._v("Commerce Hub")
          ]),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "sellShop",
              on: {
                click: function($event) {
                  return _vm.open("https://brand.shopvidi.com/", 1)
                }
              }
            },
            [_vm._v("Brand Partner")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open("https://partner.shopvidi.com/", 1)
                }
              }
            },
            [_vm._v("Wholesale Partner")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open("/vilocal")
                }
              }
            },
            [_vm._v("ViLocal")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer-right-list" }, [
        _c("ul", [
          _c("li", { staticClass: "right-list-title" }, [_vm._v("Support")]),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open("/credit-payment")
                }
              }
            },
            [_vm._v("Net 60 Terms")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open("/privacy")
                }
              }
            },
            [_vm._v("Privacy Policy")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open("/return-policy")
                }
              }
            },
            [_vm._v("Return Policy")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open("/term-service")
                }
              }
            },
            [_vm._v("Terms of Use")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open("http://help.shopvidi.com", 1)
                }
              }
            },
            [_vm._v("Help Center")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer-right-list" }, [
        _c("ul", [
          _c("li", { staticClass: "right-list-title" }, [_vm._v("Socials")]),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open("https://www.facebook.com/ShopVidiHome", 1)
                }
              }
            },
            [_vm._v("Facebook")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open(
                    "https://www.instagram.com/shopvidiwholesale/",
                    1
                  )
                }
              }
            },
            [_vm._v("Instagram")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open(
                    "https://www.linkedin.com/company/wholesaleshopvidi/",
                    1
                  )
                }
              }
            },
            [_vm._v("Linkedin")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open(
                    "https://api.whatsapp.com/send?phone=%2B17736695751",
                    1
                  )
                }
              }
            },
            [_vm._v("WhatsApp")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.open(
                    "https://maps.app.goo.gl/ezFC2r8vgoyWKguT9",
                    1
                  )
                }
              }
            },
            [_vm._v("Google Map")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-left" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/home/shopLogo.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "footer-left-title" }, [
        _vm._v(
          "\n          Global Brands, Local Retailers, One Entrepreneur Dream!\n          "
        ),
        _c("br"),
        _vm._v(
          "\n          We strive to build a wholesale community of a shared future.\n        "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "left-reserved" }, [
        _c("span", [
          _vm._v("3427 Oakcliff Rd Ste 100, Atlanta, GA, 30340 USA")
        ]),
        _vm._v(" "),
        _c("span", { staticStyle: { "margin-top": "15px" } }, [
          _vm._v("Copyright © 2025 ShopVidi Inc.")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right-reserved" }, [
      _c("span", [_vm._v("3427 Oakcliff Rd Ste 100, Atlanta, GA, 30340 USA")]),
      _vm._v(" "),
      _c("span", { staticStyle: { "margin-top": "15px" } }, [
        _vm._v("Copyright © 2025 ShopVidi Inc.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-290b96c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-290b96c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/components/homeFooter.vue
// module id = null
// module chunks = 